// Plattar QR Modal Fix for Mobile
(function() {
  'use strict';
  
  console.log('[Plattar QR Fix] Initializing...');
  
  // Function to ensure QR modal is accessible
  function ensureQRModal() {
    // Wait a bit for Plattar to initialize
    setTimeout(() => {
      // Find all QR modals from all Plattar instances
      const qrModals = document.querySelectorAll('.plattar-qr-modal, #plattar-qr-modal');
      console.log('[Plattar QR Fix] Found QR modals:', qrModals.length);
      
      // Move all QR modals to body if not already there
      qrModals.forEach((modal, index) => {
        if (modal.parentElement !== document.body) {
          document.body.appendChild(modal);
          console.log(`[Plattar QR Fix] Moved QR modal ${index + 1} to body`);
        }
        
        // Ensure modal has proper ID for reference
        if (!modal.id) {
          modal.id = `plattar-qr-modal-${index}`;
        }
      });
      
      // Set up unified event handling
      setupUnifiedARHandling();
    }, 1000);
  }
  
  // Function to handle AR events from any button
  function setupUnifiedARHandling() {
    console.log('[Plattar QR Fix] Setting up unified AR handling...');
    
    // Remove any existing handlers to prevent duplicates
    document.removeEventListener('click', handleARClick, true);
    
    // Add new handler
    document.addEventListener('click', handleARClick, true);
  }
  
  // Handler for AR button clicks
  function handleARClick(e) {
    // Check if this is an AR button
    const button = e.target.closest('[data-plattar-event="plattar-start-ar"], .mobile-view-at-home, #view-at-home-btn');
    
    if (!button) return;
    
    console.log('[Plattar QR Fix] AR button clicked:', button);
    
    // Check if we're on mobile
    const isMobile = window.innerWidth <= 768;
    
    if (isMobile) {
      // On mobile, we need to ensure the QR modal opens
      e.preventDefault();
      e.stopPropagation();
      
      // Try to trigger Plattar's AR event
      const plattarEvent = new CustomEvent('plattar-start-ar', { bubbles: true });
      document.dispatchEvent(plattarEvent);
      
      // Also try to manually show QR modal if it exists
      setTimeout(() => {
        const qrModal = document.querySelector('.plattar-qr-modal, #plattar-qr-modal');
        if (qrModal) {
          // Check if modal is not already open
          if (!qrModal.classList.contains('plattar-qr-modal--open')) {
            console.log('[Plattar QR Fix] Manually opening QR modal');
            qrModal.style.display = 'block';
            qrModal.classList.add('plattar-qr-modal--open');
            qrModal.setAttribute('aria-hidden', 'false');
          }
        } else {
          console.warn('[Plattar QR Fix] No QR modal found to open');
        }
      }, 100);
    }
  }
  
  // Function to monitor Plattar initialization
  function monitorPlattarInit() {
    const checkInterval = setInterval(() => {
      // Check if Plattar embeds exist
      const plattarEmbeds = document.querySelectorAll('plattar-embed');
      
      if (plattarEmbeds.length > 0) {
        console.log('[Plattar QR Fix] Found Plattar embeds:', plattarEmbeds.length);
        clearInterval(checkInterval);
        
        // Ensure QR modals are properly set up
        ensureQRModal();
        
        // Also check again after a delay in case of async loading
        setTimeout(ensureQRModal, 3000);
      }
    }, 500);
    
    // Stop checking after 10 seconds
    setTimeout(() => clearInterval(checkInterval), 10000);
  }
  
  // Initialize when DOM is ready
  function init() {
    console.log('[Plattar QR Fix] DOM ready, starting monitor...');
    monitorPlattarInit();
    
    // Also set up immediate handling for any existing buttons
    setupUnifiedARHandling();
  }
  
  // Start initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Also reinitialize on window load to catch late-loading elements
  window.addEventListener('load', () => {
    setTimeout(init, 500);
  });
  
  // Expose debug function
  window.plattarQRDebug = function() {
    const modals = document.querySelectorAll('.plattar-qr-modal, #plattar-qr-modal');
    const buttons = document.querySelectorAll('[data-plattar-event="plattar-start-ar"]');
    const embeds = document.querySelectorAll('plattar-embed');
    
    console.group('[Plattar QR Debug]');
    console.log('QR Modals found:', modals.length);
    modals.forEach((modal, i) => {
      console.log(`  Modal ${i + 1}:`, {
        id: modal.id,
        parent: modal.parentElement.tagName,
        classes: modal.className,
        display: window.getComputedStyle(modal).display,
        isOpen: modal.classList.contains('plattar-qr-modal--open')
      });
    });
    console.log('AR Buttons found:', buttons.length);
    console.log('Plattar Embeds found:', embeds.length);
    console.groupEnd();
  };
  
  console.log('[Plattar QR Fix] Script loaded. Debug with: window.plattarQRDebug()');
})();